import React, { useState } from "react";
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Button,
  useToast,
  HStack,
} from "@chakra-ui/react";
import HistoryItem from "./HistoryItem";
import useFetch from "../../../hooks/useFetch";
import { currencyFormatter } from "../../../Utils/formatUtils";
import ContentCard from "../../Common/Layout/ContentCard";

const HistoryList = ({ supplier }) => {
  const [historyList, setHistoryList] = useState(supplier.history);
  const [showNewPayment, setShowNewPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { post } = useFetch();
  const toast = useToast();

  const handleDelete = (supplier) => {
    /* setSelectedProduct(product);
    setIsDeleteModalOpen(true); */
  };

  const handleCreate = async (history) => {
    await post(`/suppliers/${supplier.id}/payments`, history).then(
      async (res) => {
        toast({
          title: "Pago guardado con éxito.",
          description: "Se ha guardado la información del pago.",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        setHistoryList(res.history);
      }
    );
  };

  const calculateTotal = () => {
    let total = 0;

    historyList?.map((history) => {
      total = total + history.total;
    });

    return total;
  };

  return (
    <ContentCard>
      <Heading variant="h2">{`Historial de pagos`}</Heading>
      <HStack>
        <Box textAlign="right">Balance:</Box>
        <Box
        //color={supplier.balance < 0 && "red"}
        >
          {currencyFormatter(calculateTotal())}
        </Box>
      </HStack>

      <Button
        my="2"
        colorScheme="blue"
        onClick={() => setShowNewPayment(true)}
        isDisabled={showNewPayment}
      >
        + Pago
      </Button>

      {isLoading ? (
        "Cargando"
      ) : (
        <Box overflowX={"scroll"} pb={"0.5rem"}>
          <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
            <Thead>
              <Tr>
                <Th fontSize="0.8em">Fecha</Th>
                <Th fontSize="0.8em" textAlign={"center"}>
                  Observaciones
                </Th>
                <Th fontSize="0.8em" textAlign={"right"}>
                  Monto
                </Th>
                <Th fontSize="0.8em" textAlign="center">
                  Acciones
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {showNewPayment && (
                <HistoryItem
                  history={{}}
                  setShowNewPayment={setShowNewPayment}
                  initialAction={"new"}
                  addHistory={handleCreate}
                />
              )}
              {historyList?.map((history, index) => (
                <HistoryItem
                  history={history}
                  key={index}
                  setShowNewPayment={setShowNewPayment}
                  deleteProduct={handleDelete}
                />
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </ContentCard>
  );
};

export default HistoryList;
